module.exports = __webpack_public_path__ + "img/feature-tile-icon-02.d61cf778.svg";